import { render, staticRenderFns } from "./PopClientComponent.vue?vue&type=template&id=ca106b38&scoped=true&"
import script from "./PopClientComponent.vue?vue&type=script&lang=js&"
export * from "./PopClientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca106b38",
  null
  
)

export default component.exports